<h2 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <textarea [(ngModel)]="message" class="textarea-style" rows="10"></textarea>
</mat-dialog-content>
<mat-dialog-actions>
  <button cdkFocusInitial mat-button color="warn" (click)="closeDialog(false)">{{ cancelLabel | translate }}</button>
  <button [disabled]="!(message.length > 2)" mat-button color="primary" (click)="closeDialog(true)">{{ confirmLabel | translate }}</button>
</mat-dialog-actions>
